// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"4c95636d","401":"9e50c21e","740":"3ea7394c","995":"142969ae"}[chunkId] + ".chunk.js";
};